import { types, actions } from './requests'
export const DELETEMACHINE_TYPES = {
    ...types('DELETEMACHINE'),
}
export const DELETEMACHINE_ACTIONS = {
    ...actions('DELETEMACHINE'),
}
